import { Controller } from "@hotwired/stimulus"

// Guards a real (non-Turbo) page-navigation link against accidental
// double-clicks. These links do a full browser navigation rather than a
// Turbo/AJAX submit, so there's no request lifecycle to hook a spinner into
// (see submit_spinner_controller.js for that case) -- this just marks the
// link visually "in flight" on first click and swallows any click that
// follows before the browser navigates away.
//
// Usage:
//   <%= link_to "Export", export_path,
//         data: { controller: "disable-on-click",
//                 action: "click->disable-on-click#click",
//                 disable_on_click_label_value: "Queuing..." } %>
export default class extends Controller {
  static values = { label: String }

  click(event) {
    if (this.clicked) {
      event.preventDefault()
      return
    }

    this.clicked = true

    // Freeze the current rendered width before swapping the label so a
    // longer/shorter label can't grow or shrink the link -- that would shove
    // sibling links sideways under the user's cursor mid-navigation.
    this.element.style.width = `${this.element.getBoundingClientRect().width}px`
    this.element.classList.add("pointer-events-none", "opacity-50", "justify-center", "overflow-hidden", "whitespace-nowrap")

    if (this.hasLabelValue) {
      this.element.textContent = this.labelValue
    }
  }
}
